import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CommentedItemPreview = ({ preview, href }) => {
    const style = preview.thumbnail_url ? { backgroundImage: `url(${preview.thumbnail_url})` } : null;

    let commentPreview = (
        <div
            className={classNames('trafo-preview', 'trafo-preview-medium', `trafo-preview-${preview.contenttype}`, {
                'trafo-image-preview': preview.thumbnail_url,
            })}
            style={style}
        >
            {!preview.thumbnail_url && <div className="preview-innertext">{preview.text}</div>}
            {!!preview.icon_class && <i className={preview.icon_class} />}
            {!!preview.stamp && <div className="preview-stamp">{preview.stamp}</div>}
        </div>
    );

    if (href) {
        commentPreview = <a href={href}>{commentPreview}</a>;
    }

    return <div className="comment__work">{commentPreview}</div>;
};

CommentedItemPreview.propTypes = {
    preview: PropTypes.shape({
        size: PropTypes.string,
        thumbnail_url: PropTypes.string,
        text: PropTypes.string,
        stamp: PropTypes.string,
        icon_class: PropTypes.string,
        contenttype: PropTypes.string,
    }).isRequired,
    href: PropTypes.string,
};

CommentedItemPreview.defaultProps = {
    href: null,
};

export default CommentedItemPreview;



// WEBPACK FOOTER //
// ./src/components/CommentedItemPreview.js